import './errors/registerRestRejectionFailsafe';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
// import { IconProvider } from '@ant-design/icons';
// import 'ddv-comment/dist/index.css';
import store from './flux/store';
import App from './container/entry';
import * as serviceWorker from './serviceWorker';

// import '@style/index.scss';
import './styles/components/uploadModal.scss';
import 'react-resizable/css/styles.css';
// import SocketProvider from '@components/socketManager/SocketProvider';
import { SocketProvider as CommentProvider } from './ddvComment/SocketProvider';
import { SocketProvider } from '../src/components';
import { handleSocketError } from './ddvComment/socketManager/socketErrorHandler';
import { NotificationProvider } from './ddvComment/NotificationCenter';
// import AppkitThemeContainer from '@components/appkitThemeContainer/AppkitThemeContainer';
import 'antd/dist/antd.less';
import './styles/index.scss';
import 'appkit-react/style/appkit-react.default.css';
import './styles/antd-light.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
// import './ag-grid-style.scss';
import '../src/modules/projects/projectDetail/executiveSummary/ag-grid-style.scss';

import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import { GlobalFeedbackProvider } from './errors/GlobalFeedbackProvider';

ModuleRegistry.registerModules([AllCommunityModule]);

ReactDOM.render(
  // <React.StrictMode>
  <ConfigProvider
    csp={{ nonce: 'NTNlMjMwYjctZWYzMC00MjM2LWFlNDYtN2U5NjZkOTc0Yjk2' }}
  >
    <Provider store={store}>
      {/*<AppkitThemeContainer>*/}
      <GlobalFeedbackProvider>
        <SocketProvider>
          <CommentProvider handleSocketError={handleSocketError}>
            <NotificationProvider>
              <App />
            </NotificationProvider>
          </CommentProvider>
        </SocketProvider>
      </GlobalFeedbackProvider>
      {/*</AppkitThemeContainer>*/}
    </Provider>
  </ConfigProvider>, //{' '}
  // </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
